import { DynamicTab } from "../../../components/Page";
import { HpgclTitle } from "../components";
import { TabSwitcher } from "../Hppc_Das";
import Weather from "./Weather";
import Weather2 from "./Weather2";

export function HppcWeather() {
  return (
    <>
      <DynamicTab
        headerPrefixComponent={<TabSwitcher />}
        header="Weather Forecast"
        middleComponent={<HpgclTitle />}
        tabs={{
          "Weather Forecast": <Weather />,
          "Weather Forecast 2": <Weather2 />,
        }}
      />
    </>
  );
}
